define('taoQtiItem/qtiXmlRenderer/renderers/interactions/GapMatchInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/blockInteraction'], function(tpl){
    return {
        qtiClass : 'gapMatchInteraction',
        template : tpl
    };
});
